import { ARBITRUM, AVALANCHE, BSС_MAINNET, CUSTOM_DEV_NETWORK } from "./chains";
import { isDevelopment } from "./env";

export const GMX_STATS_API_URL = `${import.meta.env.VITE_APP_BACKEND_API_URL}/api`;
// export const GMX_STATS_API_URL = "https://stats.gmx.io/api";

const BACKEND_URLS = {
  default: import.meta.env.VITE_APP_BACKEND_API_URL,

  // [BSС_MAINNET]: "https://gambit-server-staging.uc.r.appspot.com",
  [ARBITRUM]: isDevelopment()
    ? "https://gmx-server-mainnet.uw.r.appspot.com"
    : import.meta.env.VITE_APP_BACKEND_API_URL,
  // [AVALANCHE]: "https://gmx-avax-server.uc.r.appspot.com",
  [CUSTOM_DEV_NETWORK]: import.meta.env.VITE_APP_BACKEND_API_URL,
};

export function getServerBaseUrl(chainId: number) {
  if (!chainId) {
    throw new Error("chainId is not provided");
  }

  if (document.location.hostname.includes("deploy-preview")) {
    const fromLocalStorage = localStorage.getItem("SERVER_BASE_URL");
    if (fromLocalStorage) {
      return fromLocalStorage;
    }
  }

  return BACKEND_URLS[chainId] || BACKEND_URLS.default;
}

export function getServerUrl(chainId: number, path: string) {
  return `${getServerBaseUrl(chainId)}${path}`;
}
